import React from 'react';
import { PageTracker } from '../pages/ms_change_notifications';
const Pagination = ({ totalCount, setCurrentPage, setLength, currentPage, length, lengthOptions=[10, 25, 50, 100] }) => {
	let totalPage = Math.ceil(totalCount / length);
	return <div className='flex'>
		{/* per page */}
		<div className='flex items-center gap-2'>
			<p className='font-medium py-0 text-sm'>
				Show Results
			</p>
			<select className='rounded-primary border-normal border-grey p-1 pl-2 pr-11' defaultValue={length} onChange={(e) => {
				setLength(Number(e.target.value))
			}}>
				{
					lengthOptions.map((option, index) => <option key={index} value={option}>{option}</option>)
				}
			</select>
			<p className='font-medium py-0 text-sm'>
				out of {totalCount} results
			</p>
		</div>

		{
			totalPage > 1 &&
			<div className='ml-auto'>
				<PageTracker totalPage={totalPage} setPage={setCurrentPage} currentPage={currentPage} />
			</div>
		}
	</div>
}

export default Pagination;